import React, {Component} from 'react';

let pssParams = window.pss_params;

let apiURL = document.location.host;
//let apiURL = 'localhost/RiverCity';

let presales_site_url = "demos-sp-ocl-ug";
let presales_site_master = 'DEMO_NSW';
let presales_site_compliance = 'DEMO_NSW';
let presales_site_request = 'DEMO_NSW';
let presales_site_asset_register = 'ASSET';

if (pssParams) {
    presales_site_url = pssParams.presales_site_url;
    presales_site_master = pssParams.presales_site_master;
    presales_site_compliance = pssParams.presales_site_compliance;
    presales_site_request = pssParams.presales_site_request;
    presales_site_asset_register = pssParams.presales_site_asset_register;
}

let docGetIDURL = `https://${apiURL}/wp-json/presalessettings/v1/fetchecmindexitems/`;
let docViewURL = `https://${presales_site_url}.t1cloud.com/T1Default/CiAnywhere/Web/${presales_site_url.toUpperCase()}/Api/CMIS/T1/content/`;

class GetDocDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            thisDocID: this.props.docid,
            thisDocLabel: this.props.label,
            thisDocImage: this.props.image,
            docid: '',
            docHref: '',
        }
    }

    componentDidMount () {
        //this.documentID = this.props.docid;
        //console.log(this.state.thisDocID);
        this._getDocument();
    }

    componentWillReceiveProps (newProps) {
        this.setState({
            thisDocID: this.newProps.docid
        });
        //console.log(this.state.thisDocID);
        this._getDocument();
    }

    render () {
        return (
            <div className = "atProgressTitle" style={{'display': 'flex', 'align-items': 'center'}}>
                <img width={25} src={this.state.thisDocImage}/>&nbsp;<a href={this.state.docHref} target="_">{this.state.thisDocLabel}</a>
            </div>
        )
    }

    async _getDocument() {
        //console.log(thisDoc);
        try{
            await fetch(docGetIDURL + `folder-${this.state.thisDocID}`).then(response => {
                let contentType = response.headers.get("Content-Type");
                //console.log(response.statusText);
                if (contentType && contentType.includes("application/xml")) {
                    let data = response.json();
                    return data;
                }
                throw new TypeError("Oops, we haven't got XML!");
            }).then(XML => {
                //console.log(XML);
                let docParser = new DOMParser();
                let docDOM = docParser.parseFromString(XML, "application/xml");
                let documentID = docDOM.getElementsByTagName("cmis:propertyInteger").item(9).textContent;
                let ecmString = docViewURL + '?id=document-' + documentID + '&streamId=streampdf-' + documentID;
                //console.log(ecmString);
                this.setState ({
                    docHref: ecmString
                })
                return ecmString;
            }).catch(error => this.setState({error}));
        } catch (e) {
            console.log(e);
            throw e;
        }       
    }
}

export default GetDocDetails;


// WEBPACK FOOTER //
// ./src/GetDocDetails.js